export default "__VITE_ASSET__e00ef0b3__"